import { render, staticRenderFns } from "./ReportPhysicianDuty.vue?vue&type=template&id=78a5bc49&scoped=true&"
import script from "./ReportPhysicianDuty.vue?vue&type=script&lang=js&"
export * from "./ReportPhysicianDuty.vue?vue&type=script&lang=js&"
import style0 from "./ReportPhysicianDuty.vue?vue&type=style&index=0&id=78a5bc49&lang=scss&scoped=true&"
import style1 from "./ReportPhysicianDuty.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a5bc49",
  null
  
)

export default component.exports